<template>
  <div>
    <v-btn icon small @click="openDialog" style="margin: 0">
      <font-awesome-icon icon="scroll" style="color:white;"/>
    </v-btn>
    <v-dialog v-model="dialog" width="820" height="640">
      <v-card style="width:100%;height:100%;">
        <v-card-title primary class="title" style="height:10%;">{{ logsTitle }}</v-card-title>
        <v-card-media>
          <v-flex d-flex md8 style="margin-right: 32px;">
          </v-flex>
          <v-flex d-flex md12 style="padding: 16px;">
            <v-layout column>
              <v-flex d-flex md6>
                <v-select
                    label="Log type"
                    v-model="logType"
                    :items="logTypeList"
                />
              </v-flex>
              <v-flex d-flex md6 v-if="logType=='Notifications'">
                <v-layout row>
                  <v-flex d-flex md6 style="padding-right: 8px">
                    <InlineDatePicker
                        :model.sync="start_date"
                        label="Start Date"
                    />
                  </v-flex>
                  <v-flex d-flex md6 style="padding-left: 8px">
                    <InlineDatePicker
                        :model.sync="end_date"
                        :minDate="''"
                        :maxDate="''"
                        label="End Date"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex md6 v-if="logType=='Notifications' && notification_table=='maintenance_tasks'">
                <v-layout row>
                  <v-flex d-flex md12>
                    <v-autocomplete
                        flat
                        v-model="notification_type"
                        label="Notification type"
                        :items="task_types"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex md6 v-if="logType=='Notifications'">
                <v-layout row>
                  <v-flex d-flex md12>
                    <v-radio-group v-model="txt_format" row label="Log file type:">
                      <v-radio label="Plain text" value="txt"/>
                      <v-radio label="CSV" value="csv"/>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex md6 v-if="route=='Rulesets' && logType.indexOf('Onboard') > -1">
                <v-layout row>
                  <v-flex d-flex md12>
                    <v-select label="Control" v-model="control" :items="controlList" flat style="height:100%; font-size:18px; padding:0px;"/>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex md6 v-if="logType=='CBM Report'">
                <v-layout row>
                  <v-flex d-flex md12>
                    <v-autocomplete
                        flat
                        v-model="vessel"
                        label="Vessel"
                        :items="vessels"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex md6 v-if="logType=='CBM Report' && report_data_loaded">
                <v-layout row>
                  <v-flex d-flex md6 style="padding-right: 8px;">
                    <v-autocomplete
                        flat
                        v-model="cbm_report_year"
                        label="Year"
                        :items="cbm_report_years"
                    />
                  </v-flex>
                  <v-flex d-flex md6 style="padding-left: 8px;">
                    <v-autocomplete
                        flat
                        v-model="cbm_report_quarter"
                        label="Quarter"
                        :items="cbm_report_quarters"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-media>
        <v-card-actions style="height:10%;">
          <v-spacer/>
          <v-btn color="primary" flat @click="cancel">Cancel</v-btn>
          <v-btn style="color:white; background-color: rgb(51,82,128);" @click="submit">OK</v-btn>
        </v-card-actions>
      </v-card>
      <v-alert
          class='alert'
          :value="alert"
          type="error"
          transition="scale-transition"
          color='rgb(205, 57, 64)'
          outline
          dismissible
          @input="closeAlert"
          style="position: absolute; width: 500px;"
      >
        {{ alert_msg }}
      </v-alert>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import InlineDatePicker from "@/components/InlineDatePicker";
import {store} from "@/main";

export default {
  name: "LogButton",
  components: {
    InlineDatePicker
  },
  props: {
    callback: Function,
    file: String,
    output: String,
    logsTitle: String,
    notification_table: String, //The notification type to retrieve when requested.
    special: String,
    vessels:Array
  },
  data() {
    return {
      dialog: false,
      logType: '',
      logTypeList: ['Action Log', 'Notifications'],
      start_date: '',
      end_date: '',
      txt_format: 'txt',
      notification_type: '',
      control: '',
      vessel: '',
      controlList: ['All', 'WECS', 'UNIC', 'UNIC DF', 'WICE', 'WICE DF'],
      task_types: ["New", "Approved", "Reminders", "Completed"],
      alert: false,
      alert_msg: '',
      cbm_report_quarters_per_year: [],
      cbm_report_year: null,
      cbm_report_years: [],
      cbm_report_quarter: null,
      cbm_report_quarters: [],
      cbm_report_quarter_numerical: null
    }
  },
  mounted() {
    if (this.route == 'Rulesets') {
      this.logTypeList.push("Onboard validation status update info")
    }
    if (this.route == 'Maintenance Tasks') {
      this.logTypeList = ["CBM Report"].concat(this.logTypeList)
    }
  },
  methods: {
    closeAlert(v) {
      this.alert = false;
    },
    openDialog() {
      this.dialog = true;
      this.logType = '';
      this.start_date = '';
      this.end_date = '';
      this.txt_format = 'txt';
    },
    cancel() {
      this.dialog = false;
      this.logType = '';
      this.start_date = '';
      this.end_date = '';
    },
    submit() {
      if (!this.logType.length) {
        return;
      }

      if (this.logType == 'Action Log') {
        this.getLogs()
      } else if (this.logType.indexOf('Onboard') > -1) {
        this.getUpdates()
      } else if (this.logType == 'CBM Report') {
        this.getCBMReport()
      } else {
        this.getNotifications()
      }
    },
    getLogs() {
      axios.get(`${store.config.api_location}/logs/${this.file}`)
          .then((response) => {
            if (this.output == null || typeof this.output == 'undefined') {
              this.output = this.file;
            }

            let contentType = response.headers["content-type"] || 'application/octet-stream';

            try {
              let blob = new Blob([response.data], {type: contentType}),
                  url = URL.createObjectURL(blob),
                  anchor = document.createElement('a');

              anchor.href = url;
              anchor.download = `${this.output}.log`;

              document.body.appendChild(anchor);
              anchor.click();
              document.body.removeChild(anchor);

              URL.revokeObjectURL(url)
            } catch (exc) {
              console.log(exc)
            } finally {
              this.cancel()
            }
          })
          .finally(() => {
            this.cancel()
          })
    },
    getNotifications() {
      let entity = 'faults';

      let url = new URL(`${store.config.api_location}/${entity}/notifications/printout/${this.notification_table}`),
          start_date, end_date;

      if (!!this.start_date) {
        start_date = new Date(this.start_date)
        start_date.setHours(0);
        start_date.setMinutes(0);
        start_date.setSeconds(0);
        start_date.setMilliseconds(0);
        start_date = start_date.toISOString().split('.')[0].replace('T', ' ');

        if (!!this.end_date) {
          end_date = new Date(this.end_date)
          end_date.setHours(23);
          end_date.setMinutes(59);
          end_date.setSeconds(59);
          end_date.setMilliseconds(0);
          end_date = end_date.toISOString().split('.')[0].replace('T', ' ');

          if (start_date <= end_date) {
            url.pathname += `/${start_date}`;
            url.pathname += `/${end_date}`;
          } else {
            url.pathname += `/${end_date}`;
            url.pathname += `/${start_date}`;
          }
        } else {
          url.pathname += `/${start_date}`
        }
      } else if (!!this.end_date) {
        end_date = new Date(this.end_date)
        end_date.setHours(0);
        end_date.setMinutes(0);
        end_date.setSeconds(0);
        end_date.setMilliseconds(0);
        end_date = end_date.toISOString().split('.')[0].replace('T', ' ');

        url.pathname += `/${end_date}`
      }

      url.pathname += `/${this.txt_format}`;

      if (!!this.notification_type) {
        url.pathname += `/${this.notification_type}`;
      }

      axios.get(url.toString(), {responseType: 'arraybuffer'})
          .then((response) => {
            if (this.output == null || typeof this.output == 'undefined') {
              this.output = this.file;
            }

            let contentType = response.headers["content-type"] || 'application/octet-stream';

            try {
              // let blob = new Blob([response.data], {type: contentType}),
              let blob = new Blob([response.data], {type: contentType}),
                  url = URL.createObjectURL(blob),
                  anchor = document.createElement('a');

              anchor.href = url;
              if (contentType.toLowerCase().indexOf('zip') > -1) {
                anchor.download = `${this.output}-notifications.zip`;
              } else {
                anchor.download = `${this.output}-notifications.${this.txt_format}`;
              }

              document.body.appendChild(anchor);
              anchor.click();
              document.body.removeChild(anchor);

              URL.revokeObjectURL(url)
            } catch (exc) {
            } finally {
              this.cancel()
            }
          })
          .finally(() => {
            this.cancel()
            this.txt_format = 'txt';
            this.notification_type = '';
          })
    },
    getUpdates() {
      let control = this.control.toLowerCase().replace(' ', '_'),
          url = new URL(`${store.config.api_location}/faultrules/formatted`),
          output = 'rulesets.txt';

      if (control.length && control != 'all') {
        url.pathname += `/${control}`
        output = `${control}_${output}`;
      }

      axios.get(url.toString())
          .then((response) => {
            let contentType = response.headers["content-type"] || 'application/octet-stream';

            try {
              let blob = new Blob([response.data], {type: contentType}),
                  url = URL.createObjectURL(blob),
                  anchor = document.createElement('a');

              anchor.href = url;
              anchor.download = output;

              document.body.appendChild(anchor);
              anchor.click();
              document.body.removeChild(anchor);

              URL.revokeObjectURL(url)
            } catch (exc) {
              console.log(exc)
            } finally {
              this.cancel();
            }
          })
          .finally(() => {
            this.cancel();
          })
    },
    getCBMReport() {
      if (this.vessel.length && this.cbm_report_year != null && this.cbm_report_quarter_numerical != null) {
        let report_path = `${store.config.api_location}/maintenance/tasks/report/${this.vessel}/year/${this.cbm_report_year}/quarter/${this.cbm_report_quarter_numerical}`

        axios.get(`${report_path}?${(new Date()).getTime()}`, {responseType: 'arraybuffer'}).then((res) => {
          if (res.headers["content-type"] == 'application/pdf') {
            try {
              let blob = new Blob([res.data], {type: 'application/pdf'}),
                  url = URL.createObjectURL(blob),
                  anchor = document.createElement('a');

              anchor.href = url;
              anchor.download = `CBM Report - ${this.vessel} - ${this.cbm_report_quarter} ${this.cbm_report_year}.pdf`;

              document.body.appendChild(anchor);
              anchor.click();
              document.body.removeChild(anchor);

              URL.revokeObjectURL(url)
            } catch (e) {
              console.log(e);
            }
          } else if ('application/json' == res.headers["content-type"]) {
            this.alert = true;
            this.alert_msg = res.data.msg;
          }
        });
      } else {
        console.log(this.vessel.length, this.cbm_report_year, this.cbm_report_quarter_numerical)
      }
    },
    getCBMReportQuarters() {
      this.cbm_report_quarters_per_year = null;
      this.cbm_report_years = null;
      this.cbm_report_year = null;

      axios.get(`${store.config.api_location}/maintenance/tasks/report/${this.vessel}/dates?${(new Date()).getTime()}`).then((res) => {
        if (typeof res != 'undefined' && res.status == 200) {
          console.log(res.data)
          this.cbm_report_quarters_per_year = res.data.data.years;
          this.cbm_report_years = Object.keys(res.data.data.years);
        }
      });
    }
  },
  computed: {
    route: function () {
      return this.$route.name
    },
    report_data_loaded: function () {
      return this.cbm_report_years != null && this.cbm_report_years.length > 0;
    }
  },
  watch: {
    vessel: function (new_value) {
      if (new_value.length) {
        if (this.logType == 'CBM Report') {
          this.getCBMReportQuarters()
        }
      }
    },
    cbm_report_year: function (new_value) {
      if (new_value == null) {
        this.cbm_report_quarters = [];
        this.cbm_report_quarter = null;
        this.cbm_report_quarter_numerical = null;
      } else {
        this.cbm_report_quarters = Object.values(this.cbm_report_quarters_per_year[this.cbm_report_year])
      }
    },
    cbm_report_quarter: function (new_value) {
      switch (this.cbm_report_quarter) {
        case 'First Quarter':
          this.cbm_report_quarter_numerical = 1;
          break;
        case 'Second Quarter':
          this.cbm_report_quarter_numerical = 2;
          break;
        case 'Third Quarter':
          this.cbm_report_quarter_numerical = 3;
          break;
        case 'Fourth Quarter':
          this.cbm_report_quarter_numerical = 4;
          break;
        default:
          this.cbm_report_quarter_numerical = null;
      }
    }
  }
}
</script>

<style scoped>

</style>